import { Vehicle } from "@tm/models"
import { QueryClient } from "react-query"
import { fetchVehicleRecords } from "@tm/data/vehicleRecords"
import { ajaxAuth } from "@tm/utils"
import { getVehicleGsiServiceUrl } from "./helper"

export async function saveVehicle(vehicle: Vehicle, queryClient: QueryClient): Promise<Vehicle> {
    const savedVehicle = await save(vehicle)

    // Previously updating the vehicle records was done in the GSI service
    // We had to remove it there (for now) because it was blocking the SaveVehicle handler from finishing earlier --> will be fixed in NEXT-23839 (then this can be removed here)
    // Therefor we moved this call to the frontend, but it should be removed here as soon as we support non-blockin service-to-service calls in the backend.
    setTimeout(() => fetchVehicleRecords(vehicle.id, queryClient))

    return savedVehicle
}

async function save(vehicle: Vehicle): Promise<Vehicle> {
    await ajaxAuth({
        url: `${getVehicleGsiServiceUrl()}/SaveVehicle`,
        body: {
            ...vehicle,
            // returnNewVersion: true, // TODO: Service now could directly return the updated vehicle
            preventUpdateVehicleRecords: true, // Set this parameter so the GSI service handler skips calling "UpdateVehicleRecords" itself
        },
        method: "POST",
    })

    return vehicle
}
